// weather.service.ts
import { Injectable } from '@angular/core';
import { WeatherCode, weatherIconMap } from '../models/weather-code';

@Injectable({
  providedIn: 'root',
})
export class WeatherService {
  constructor() {}

  extractAndSetWeatherData(weatherModel: any, result: any) {
    const factor = Math.pow(10, 0);
    const todayMin = Math.ceil(result.minTemperature! * factor) / factor;
    const todayMax = Math.ceil(result.maxTemperature! * factor) / factor;
    const icon = this.getIconNameByWeatherCode(result.weatherCode!);

    weatherModel.set({
      current: result.currentTemperature,
      today_min: todayMin,
      today_max: todayMax,
      weather_icon: icon,
    });
  }

  getIconNameByWeatherCode(weatherCode: WeatherCode): string {
    return weatherIconMap[weatherCode];
  }
}
